import React from 'react';
import whatImg from 'src/assets/images/landing-page/turbo/what.svg';

export default function WhatImage() {
  return (
    <div className="what-image shake-card-left">
      <img src={whatImg} alt="" />
    </div>
  );
}
